import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router v6 doesn't reset scroll position on route change — by default
 * a navigation to a new route keeps the previous page's scroll offset. Mount
 * this once inside the router context and it resets to top on every
 * pathname change.
 *
 * Renders nothing. Side-effect only.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
